import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import * as Yup from "yup";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 600,
  },

  maxHeight: "70vh",
  minHeight: "25vh",
  height: "fit-content",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  paddingTop: "4vh",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  title: string;
  description: string;
  isCautionRequired: boolean;
  fields: {
    title: string;
    name: string;
    isRtl: boolean;
  }[];
  openModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  handleSubmitModal: Function;
}
const BankInfoActionModal = ({
  fields,
  title,
  description,
  openModal,
  setOpenModal,
  handleSubmitModal,
  isCautionRequired,
}: Props) => {
  const initialValues = fields?.reduce<Record<string, string>>((acc, field) => {
    acc[field.name] = "";
    return acc;
  }, {});

  const validation = Yup.object().shape(
    fields?.reduce<Record<string, Yup.StringSchema>>((acc, field) => {
      acc[field?.name] = Yup.string().required(
        `لطفا ${field?.title} را وارد نمایید.`
      );
      return acc;
    }, {})
  );

  const handleFormSubmit = (values: Record<string, string>) => {
    const formattedValues = Object.keys(values).map((key) => ({
      name: key,
      value: values[key],
    }));
    handleSubmitModal(formattedValues);
  };
  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"2rem"}
            height={"100%"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                color={"#1D4A87"}
                fontSize={"1.1rem"}
                fontWeight={600}
              >
                {title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{ fontSize: "1rem", color: "#1D4A87", textAlign: "start" }}
              >
                {description}
              </Typography>
            </Grid>
            <Formik
              initialValues={initialValues}
              onSubmit={handleFormSubmit}
              validationSchema={validation}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <Grid item sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"3rem"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      {fields?.map((field, index) => (
                        <Grid
                          item
                          xs={12}
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Typography
                            sx={{
                              width: "fit-content",
                              fontWeight: "500",
                              fontSize: "1rem",
                            }}
                          >
                            {field?.title}:
                          </Typography>
                          <Box sx={{ flexGrow: 1 }}>
                            <MaterialTextFieldComponent
                              placeHolder={field.title}
                              label={field.title}
                              required={true}
                              name={field.name}
                              id={field.name}
                              helperText={
                                touched[field.name] ? errors[field.name] : ""
                              }
                              error={
                                touched[field.name] &&
                                Boolean(errors[field.name])
                              }
                              onChange={handleChange}
                              value={values[field.name]}
                              onBlur={handleBlur}
                              inputProps={{
                                style: {
                                  direction: field.isRtl ? "rtl" : "ltr",
                                },
                              }}
                            />
                          </Box>
                        </Grid>
                      ))}
                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"center"}
                          gap={"1rem"}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"200px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                values &&
                                Object.values(values).some((value) => !value)
                              }
                              className={
                                values &&
                                Object?.values(values)?.some((value) => !value)
                                  ? isCautionRequired
                                    ? "btnForm DangerDisable"
                                    : "btnForm disabledBtn"
                                  : isCautionRequired
                                  ? "btnForm DangerDefault"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              {title}
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"200px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenModal(false);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default BankInfoActionModal;
